import React from 'react';
import { motion } from 'framer-motion';
export function RevelationSection() {
  return <section className="bg-navy text-white py-20 md:py-28 px-4" data-id="element-203">
      <div className="max-w-3xl mx-auto text-center" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-205">
          <h2 className="text-3xl md:text-5xl text-gold mb-10" data-id="element-206">
            La Razón Real por la que los Latinos de Fe No Progresan en EE.UU.
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-white/90 leading-relaxed text-left" data-id="element-207">
            <p data-id="element-208">
              No es falta de talento. No es falta de oración. Es la ausencia de
              lo que llamamos la{' '}
              <strong className="text-gold" data-id="element-209">
                "Mayordomía de Alto Rendimiento"
              </strong>
              : la combinación de principios bíblicos + sistemas empresariales
              modernos.
            </p>

            <p data-id="element-210">
              Sin este sistema, puedes orar toda la noche pero amanecer sin un
              plan. Puedes tener el talento de Bezaleel (el artesano del
              tabernáculo) pero sin estructura legal, sin marketing y sin un
              sistema de ventas... ese talento queda enterrado.
            </p>

            <div className="p-6 md:p-8 border border-gold/30 bg-white/5 rounded-lg mt-8 text-center" data-id="element-211">
              <p className="text-xl md:text-2xl font-bold text-gold italic" data-id="element-212">
                "Emprender con Unción" es el puente entre tu fe y tu libertad
                financiera.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}